import { t } from "i18next";
import { Mood, moodBgColour, moodData, moodFace } from "UIPalette/MoodTrackerCard/moodFactories";
import { Icon } from "UIPalette/Icon/Icon";
import { ContextMenu, ContextMenuListItem } from "shared/UI/ContextMenu/ContextMenu";
import "shared/extensions/date";

export const TodaysMoodCard = ({ currentMood, clearCurrentMoodValue }: { currentMood: Mood; clearCurrentMoodValue: () => void }) => {
  const data = moodData(currentMood);

  return (
    <div className="h-[100px] flex flex-col justify-between">
      <h2 className="flex flex-row items-center">
        <Icon icon={moodFace(currentMood, "38")} bgColour={moodBgColour(currentMood)} useSetWidth={false} />
        <span className="flex-grow ml-2">{data?.title}</span>
        <ContextMenu
          menuPosition="left"
          aria-label={t("trackers.actionsMenu")}
        >
          <ContextMenuListItem
            text={t("trackers.deleteLastRecord")}
            onClick={() => clearCurrentMoodValue()}
          />
        </ContextMenu>
      </h2>
      <p>{data?.description}</p>
    </div>
  );
};
